(function($){

  $(function(){

    //frontpage carousel
    $('.promo-carousel').slick({
      autoplay: true,
      dots: true,
      arrows: true
    });

    //Init search
    if ($('#search-form').length === 1 && initSearchForm !== undefined ) {

      initSearchForm();
    }


    window.UNISKI_SETTINGS = window.UNISKI_SETTINGS || {};

    UNISKI_SETTINGS.bindEvents = function(context) {
      context = context || document;

      $('a[data-reveal-id]', context).click(function() {
        var $this = $(this);

        //reset some dialong features:
        $('.js-fullPayment-select', $dialog).show();

        if ($this.data('id')) {
          
          var id = $this.data('id');
          var $dialog = $('#' + $this.data('reveal-id'))
          var $action = $dialog.find('.action');

          if ($action.attr('action')) $action.attr('action',$action.attr('action').replace('@id', id) );
          else $action.attr('href',$action.data('action').replace('@id', id) );


          //Always should be informend in the finish payment context
          if ($this.data('pending-amount')) {
            $('.js-pending-amount', $dialog).text($this.data('pending-amount'));
          }

          if ($this.data('hide-fullpayment')) {
            $('.js-fullPayment-select', $dialog).hide();
          }

        }
      });

      $('button[data-reveal-id]', context).click(function(e) {
        $button = $(this);

        $action = $('#' + $(this).data('reveal-id')).find('.action');
        $action.click(function() { $button.closest('form').submit() });

        return true;

      });

      $('.js-extendable', context).each(function() {
        if ($(this).height() >= 300) {
          $(this).append('<div class="extend-button"><span>Más información</span></div>')
          .find('.extend-button')
          .click(function() {
            $(this).closest('.js-extendable').toggleClass('extended')
          });
        }
      });


      $('.js-show-booking', context).click(function(e) {
        e.preventDefault();
        $('#' + $(this).data('booking-id')).slideToggle();
      });

      //Reveal control
      $('.reveal-modal .close', context).click(function() {
        $(this).closest('.reveal-modal').foundation('reveal','close');
      });


      $('#message-modal', context).foundation('reveal','open');

      $('.js-show-more-options', context).click(function() {
        var $this  = $(this),
            parent = $this.closest('.result');

        if ($this.hasClass('extended')) {
          parent.find('.regime.js-hiddable').addClass('hide');  
          $this.removeClass('extended');
          $this.text('Mostrar más opciones ...');
        } else {
          parent.find('.regime.js-hiddable.hide').removeClass('hide');
          $this.addClass('extended');
          $this.text('Mostrar menos opciones');
        }

      });

    };

    UNISKI_SETTINGS.bindEvents();

  })
})(jQuery);
